import { useEffect, useRef, useState } from 'react'
import { Form, Select, Radio, Button, Image, Upload, message } from 'antd'
import { FileAddOutlined, FileDoneOutlined, VideoCameraAddOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import useGlobalModel from '@/model/globalModel'
import { YHModal } from '@/components/YHModal'
import { baseModel } from '../model'
import { globalPrompt } from '@/components/message'
import { Service } from '../service'
import {
    getBaseImgLookUrl,
    getBaseImgUploadUrl,
    getBaseUploadData,
    getToken,
    oldGetBaseRequestUrl
} from '@/utils/constants'
import moment from 'moment'
import { createUuid } from '@/utils/utils'

import './style.scss'

export const EditModal = () => {
    const { editVisible, setEditVisible, mode, loadData, driverList, setDriverList, meetingTypeList } = baseModel()
    const [checkUserType, setCheckUserType] = useState<string>('')
    const [checkUserList, setCheckUserList] = useState<any>([])
    const [checkUserValue, setCheckUserValue] = useState<string[]>([])
    const [documentList, setDocumentList] = useState<any[]>([])
    const [videoList, setVideoList] = useState<any[]>([])
    const [qrcodeImg, setQrcodeImg] = useState<string>('')
    const formRef = useRef<IYhFormRef>()
    const disabledDate = (current: any) => {
        return current && current < new Date()
    }

    const {
        user: { createUser }
    } = useGlobalModel(({ user }) => [user])

    useEffect(() => {
        if (editVisible.visible && mode === 'edit') {
            getDetails().then(() => {
            })
        } else {
            editVisible.value = { id: createUuid() }
            setEditVisible(editVisible)
            setCheckUserType('')
            setCheckUserList([])
            setCheckUserValue([])
            setDocumentList([])
            setVideoList([])
            setQrcodeImg('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editVisible.visible])

    useEffect(() => {
        if (driverList?.length > 0) {
            const uniqueFleet: any[] = []
            const fleetSet = new Set(driverList.map((item: any) => item.fleet))
            fleetSet.forEach((value) => {
                uniqueFleet.push(value)
            })
            setCheckUserList(uniqueFleet)
        }
    }, [driverList])

    const getDetails = async () => {
        let response = await Service.one(editVisible.value.id)
        response.retData.startTime = moment(response.retData.startTime)
        response.retData.documentList = []
        response.retData.videoList = []
        if (response.retData.driverInformationList && response.retData.driverInformationList.length > 0) {
            let _meetingsUser: string[] = []
            let _meetingsUserList: { userId: string }[] = []
            let _type: string[] = []
            let _fleet: string[] = []
            response.retData.driverInformationList.forEach((item: any) => {
                _meetingsUser.push(item.id)
                _meetingsUserList.push({ userId: item.id })
                if (_type.length === 0 || _type[0] !== item.type) {
                    _type.push(item.type)
                }
                if (_fleet.length === 0 || _fleet[0] !== item.fleet) {
                    _fleet.push(item.fleet)
                }
            })

            if (response.retData.driverInformationList.length === driverList.length) {
                setCheckUserType('全部')
            }
            response.retData.meetingsUser = _meetingsUser
            response.retData.meetingsUserList = _meetingsUserList
            setCheckUserValue(response.retData.meetingsUser)
        }
        if (response.retData.onlineMeetingDetailsList && response.retData.onlineMeetingDetailsList.length > 0) {
            response.retData.onlineMeetingDetailsList.forEach((item: any) => {
                if (item.documentPath) {
                    response.retData.documentList.push({
                        uid: item.documentPath,
                        status: 'done',
                        name: item.documentPath,
                        response: {
                            retData: item.documentPath
                        }
                    })
                }
                if (item.videoPath) {
                    response.retData.videoList.push({
                        uid: item.videoPath,
                        status: 'done',
                        name: item.videoPath,
                        response: {
                            retData: item.videoPath
                        }
                    })
                }
            })
            setDocumentList(response.retData.documentList)
            setVideoList(response.retData.videoList)
        }
        if (response.retData.qrcodePath) {
            setQrcodeImg(response.retData.qrcodePath)
        }
        formRef.current?.setFieldsValue({ ...response.retData })
    }

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            let _data = JSON.parse(JSON.stringify(val))

            _data.id = editVisible.value.id
            _data.meetingMode = '线下'
            _data.createUser = createUser
            _data.startTime = moment(val.startTime).format('YYYY-MM-DD HH:mm')
            _data.onlineMeetingDetailsList = []
            if (checkUserValue?.length > 0) {
                _data.meetingsUserList = checkUserValue.map((item: string) => {
                    return {
                        userId: item
                    }
                })
            }

            if (documentList && documentList?.length > 0) {
                _data.onlineMeetingDetailsList = documentList.map((item: any) => ({ documentPath: item?.response?.retData }))
            }
            if (videoList && videoList?.length > 0) {
                _data.onlineMeetingDetailsList = [..._data.onlineMeetingDetailsList, ...videoList.map((item: any) => ({ videoPath: item?.response?.retData }))]
            }

            if (!qrcodeImg) {
                message.error(`请生成二维码！`)
                return false
            } else {
                _data.qrcodePath = qrcodeImg
            }

            try {
                let setData: any
                if (mode === 'add') {
                    setData = Service.insert
                }
                if (mode === 'edit') {
                    setData = Service.edit
                }
                let response = await setData(_data)
                if (response.retCode === 200) {
                    setEditVisible({ visible: false, value: {} })
                    message.success(mode === 'add' ? '添加成功！' : mode === 'edit' ? '编辑成功！' : '')
                    await loadData()
                }
            } catch (error) {
                await message.warning(error)
            }
        })
    }
    const handleChangeUserSelect = (val: string[]) => {
        const updatedDriverList = driverList.map((item: { value: string; isChecked: boolean }) => {
            if (val.includes(item.value)) {
                return { ...item, isChecked: true }
            } else {
                return { ...item, isChecked: false }
            }
        })
        setDriverList(updatedDriverList)
        formRef.current?.setFieldsValue({ meetingsUser: val })
        setCheckUserValue(val)
    }
    const handleCheckUserType = (event: any) => {
        let value = event.target.value
        let selectedValues: string[] = []
        const updatedDriverList = driverList.map((item: any) => {
            let isChecked = false
            if (value === '全部') {
                isChecked = true
                selectedValues.push(item.value)
            } else if (value === '司机' || value === '押运员') {
                if (item.type === value) {
                    isChecked = true
                    selectedValues.push(item.value)
                }
            } else {
                if (item.fleet === value) {
                    isChecked = true
                    selectedValues.push(item.value)
                }
            }
            return { ...item, isChecked }
        })
        setCheckUserType(value)
        setDriverList(updatedDriverList)
        formRef.current?.setFieldsValue({ meetingsUser: selectedValues })
        setCheckUserValue(selectedValues)
    }

    const handleGetQrcode = async () => {
        let response = await Service.downloadQrcode(editVisible.value.id)
        const formData = new FormData()
        formData.append('appCode', 'tlpt')
        formData.append('fileMode', '0')
        formData.append('file', response.data, 'qrcode.png')
        let fileResponse = await fetch(`${oldGetBaseRequestUrl()}/fsrv/upload_file?Authorization=${getToken()}`, {
            method: 'POST',
            body: formData,
            headers: {
                Authorization: `${getToken()}` // 如果需要身份验证的话
            }
        })
        const data = await fileResponse.json()
        if (data && data.retData) {
            setQrcodeImg(data.retData)
        }
    }
    const handleDownloadQrcode = async () => {
        if (!qrcodeImg) {
            await message.error('请先生成二维码！')
            return false
        }
        const link = document.createElement('a')
        link.href = getBaseImgLookUrl(qrcodeImg)
        link.download = 'qrcode.png' // 设置下载的文件名
        link.target = '_blank' // 在新窗口打开
        link.rel = 'noopener noreferrer' // 防止安全风险
        document.body.appendChild(link) // 将链接添加到文档中
        link.click() // 触发下载
        document.body.removeChild(link) // 下载完成后移除链接
    }

    const onPreview = (file: any) => {
        let url = file?.response?.retData
        if (url) {
            window.open(getBaseImgLookUrl(url))
        }
    }
    const handleUploadChange = async (e: any, type: string) => {
        if (type === 'document') {
            setDocumentList(e.fileList)
        } else if (type === 'video') {
            setVideoList(e.fileList)
        }

        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode === 0) {
                let _list = e.fileList.filter((item: any) => item.status === 'done')
                if (type === 'document') {
                    setDocumentList(_list)
                } else if (type === 'video') {
                    setVideoList(_list)
                }
            } else {
                await message.error('文件上传失败，请重新上传!')
            }
        }
        return { ...e, fileList: type === 'document' ? documentList : videoList }
    }

    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '时间',
                fieldName: 'startTime',
                format: 'YYYY-MM-DD HH:mm',
                showTime: true,
                disabledDate,
                span: 24,
                rules: [{ required: true, message: '请选择时间' }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '地点',
                fieldName: 'location',
                span: 24,
                rules: [{ required: true, message: '请填写地点' }]
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '对象',
                fieldName: 'meetingsUser',
                span: 24,
                formItem: (
                    <Form.Item name="meetingsUser" label="对象"
                               rules={[{ required: true, message: '请选择对象' }]}>
                        <div>
                            <Select
                                mode="multiple"
                                value={checkUserValue}
                                showSearch
                                options={driverList}
                                filterOption={(input: string, option: any) => {
                                    return option?.label.toLowerCase().includes(input.toLowerCase())
                                }
                                }
                                placeholder="对象"
                                onChange={handleChangeUserSelect}
                            />
                            <Radio.Group value={checkUserType} onChange={handleCheckUserType}>
                                <Radio.Button value="全部">全部</Radio.Button>
                                <Radio.Button value="司机">司机</Radio.Button>
                                <Radio.Button value="押运员">押运员</Radio.Button>
                                {checkUserList.map((item: any, index: number) => {
                                    return (
                                        <Radio.Button key={index} value={item}>
                                            {item || '-'}
                                        </Radio.Button>
                                    )
                                })}
                            </Radio.Group>
                        </div>
                    </Form.Item>
                )
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '类型',
                fieldName: 'meetingType',
                options: meetingTypeList.map((item: any) => ({ label: item, value: item })),
                span: 24,
                rules: [{ required: true, message: '请选择类型' }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主题',
                fieldName: 'title',
                span: 24,
                rules: [{ required: true, message: '请填写主题' }]
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '主讲人',
                fieldName: 'presenter',
                span: 24,
                rules: [{ required: true, message: '请填写主讲人' }],
                maxLength: 8
            },
            {
                type: FormItemTypeEnum.TextArea,
                fieldLabel: '内容',
                fieldName: 'content',
                span: 24,
                rules: [{ required: true, message: '请填写内容' }]
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '签到码',
                fieldName: 'image',
                span: 24,
                formItem: (
                    <Form.Item name="qrcodeImg" label="签到码" required>
                        <div className="meeting-form-qrcode-box">
                            <div className="image">
                                <Image
                                    width={100}
                                    height={100}
                                    src={getBaseImgLookUrl(qrcodeImg)}
                                    fallback="data:image/png;base64,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"
                                />
                            </div>
                            <div className="tools">
                                <Button type="primary" size="small" onClick={handleGetQrcode}>
                                    生成二维码
                                </Button>
                                <Button type="primary" size="small" onClick={handleDownloadQrcode}>
                                    下载二维码
                                </Button>
                            </div>
                        </div>
                    </Form.Item>
                )
            }, {
                type: FormItemTypeEnum.Other,
                fieldLabel: '文档',
                fieldName: 'document',
                span: 24,
                formItem: (
                    <Form.Item name="documentList" label="上传文档" valuePropName="documentList">
                        <Upload
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            onChange={(e) => handleUploadChange(e, 'document')}
                            listType="picture"
                            fileList={documentList}
                            accept=".doc,.docx,.pdf,.xls,.xlsx,.ppt,.pptx"
                            beforeUpload={async (file: any) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                let filetypes: string[] = ['.doc', '.docx', '.pdf', '.xls', '.xlsx', '.ppt', '.pptx']
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    await message.error('不支持该格式的上传,当前仅支持文档类型文件')
                                }
                                return isType
                            }}
                            iconRender={(file) => {
                                return (
                                    <FileDoneOutlined
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                    />
                                )
                            }}
                        >
                            <Button icon={<FileAddOutlined />}>选择文档上传</Button>
                        </Upload>
                    </Form.Item>
                )
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '视频',
                fieldName: 'video',
                span: 24,
                formItem: (
                    <Form.Item name="videoList" label="上传视频" valuePropName="videoList">
                        <Upload
                            name="file"
                            action={getBaseImgUploadUrl()}
                            data={getBaseUploadData()}
                            onChange={(e) => handleUploadChange(e, 'video')}
                            listType="picture"
                            fileList={videoList}
                            accept=".mp4,.avi,.mov,.wmv,.flv,.mkv,.rmvb"
                            beforeUpload={async (file: any) => {
                                let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
                                let filetypes: string[] = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.mkv', '.rmvb']
                                let isType = filetypes?.includes(fileEnd)
                                if (!isType) {
                                    await message.error('不支持该格式的上传,当前仅支持视频类型文件')
                                }
                                return isType
                            }}
                            iconRender={(file) => {
                                return (
                                    <VideoCameraOutlined
                                        onClick={() => {
                                            onPreview(file)
                                        }}
                                    />
                                )
                            }}
                        >
                            <Button icon={<VideoCameraAddOutlined />}>选择视频上传</Button>
                        </Upload>
                    </Form.Item>
                )
            }
        ]
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox = {
        formRef,
        labelAlign: 'right',
        onChange,
        boxs: [formItem]
    }

    const onClose = () => {
        globalPrompt('modal', {
            title: mode === 'add' ? '新增' : mode === 'edit' ? '编辑' : '查看',
            type: 'warning',
            text: mode === 'add' ? '您还有正在新增的记录...是否关闭？' : mode === 'edit' ? '您还有正在编辑的记录...是否关闭？' : '是否关闭？',
            okText: '关闭页面',
            onOk: () => setEditVisible({ visible: false, value: {} }),
            cancelText: mode === 'add' ? '继续添加' : mode === 'edit' ? '继续编辑' : '继续查看',
            onCancel: () => {
                return
            }
        })
    }

    return (
        <YHModal
            visible={editVisible.visible}
            title={mode === 'add' ? '您正在添加...' : mode === 'edit' ? '您正在编辑...' : '您正在查看...'}
            cancelText={mode === 'add' ? '取消添加' : mode === 'edit' ? '取消编辑' : '取消'}
            okText={mode === 'add' ? '确定添加' : mode === 'edit' ? '确定编辑' : '确定'}
            onCancel={onClose}
            onOk={onOk}
            width={700}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
